export default __webpack_public_path__ + "static/media/Mark-2-HUD-System Shutdown.e94f2972.jpg";